import styled, { StyledProp } from '@/styled';

import LessonExpired from './Expired';
import LessonMultipleAccess from './MultipleAccess';
import LessonNotRelesed from './NotReleased';
import BlockedBySomenone from '../Base/BlockedBySomeone';
import NotAuthenticated from '../Base/NotAuthenticated';
import NotPurchased from '../Base/NotPurchased';

const LessonAlerts = (props: StyledProp) => {
  return (
    <>
      <LessonExpired className={props.className} />
      <LessonNotRelesed className={props.className} />
      <LessonMultipleAccess className={props.className} />
      <NotAuthenticated className={props.className} />
      <BlockedBySomenone className={props.className} />
      <NotPurchased className={props.className} />
    </>
  );
};

export default styled(LessonAlerts)`
  margin-bottom: ${({ theme }) => theme.space.pxToRem(8)};
`;
